import { render } from "./TAICreateView.vue?vue&type=template&id=5a1ca3e2&scoped=true"
import script from "./TAICreateView.vue?vue&type=script&lang=js"
export * from "./TAICreateView.vue?vue&type=script&lang=js"

import "./TAICreateView.vue?vue&type=style&index=0&id=5a1ca3e2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a1ca3e2"]])

export default __exports__